import { render, staticRenderFns } from "./SubscriptionPlanFormSkeleton.vue?vue&type=template&id=11616946&scoped=true"
import script from "./SubscriptionPlanFormSkeleton.vue?vue&type=script&lang=js"
export * from "./SubscriptionPlanFormSkeleton.vue?vue&type=script&lang=js"
import style0 from "./SubscriptionPlanFormSkeleton.vue?vue&type=style&index=0&id=11616946&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11616946",
  null
  
)

export default component.exports